var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support_badge-white.svg",
    clipPath: "url(#clip0_62_1208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1708 4.45903C8.2266 7.12411 2.29505 17.3864 4.96009 27.3345C7.62512 37.2826 17.8921 43.2036 27.8363 40.5385C37.7805 37.8734 43.712 27.6111 41.047 17.6631C38.382 7.715 28.115 1.79395 18.1708 4.45903ZM28.8251 44.2295C16.8331 47.4434 4.48066 40.3072 1.27036 28.3238C-1.93995 16.3403 5.19016 3.98271 17.1822 0.768786C29.1559 -2.44019 41.5267 4.6911 44.737 16.6745C47.9473 28.658 40.7988 41.0205 28.8251 44.2295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1373 15.531C17.2998 16.5595 15.0008 20.526 16.0301 24.368C17.0598 28.2117 21.0331 30.4953 24.8706 29.4668C28.708 28.4384 31.0075 24.4737 29.9778 20.6299C28.9485 16.788 24.9747 14.5026 21.1373 15.531ZM25.8593 33.1575C19.9739 34.7348 13.9147 31.2342 12.3402 25.3569C10.7657 19.4796 14.2632 13.4178 20.1486 11.8405C26.0155 10.2681 32.0931 13.7638 33.6676 19.6411C35.2421 25.5184 31.7262 31.5852 25.8593 33.1575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.208 15.9242C16.6915 16.0626 16.1748 15.758 16.0384 15.2487L13.2785 4.94637C13.1415 4.43521 13.4372 3.91493 13.9537 3.77649C14.4519 3.64298 14.9865 3.94076 15.1234 4.45192L17.8833 14.7543C18.0198 15.2636 17.7062 15.7907 17.208 15.9242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7355 13.9059C24.2189 14.0443 23.7023 13.7397 23.5658 13.2304L20.8059 2.92803C20.669 2.41688 20.9646 1.8966 21.4812 1.75815C21.9978 1.61971 22.5139 1.92243 22.6508 2.43358L25.4108 12.736C25.5472 13.2453 25.2521 13.7674 24.7355 13.9059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5411 43.2953C24.0246 43.4337 23.5079 43.1292 23.3715 42.6199L20.6115 32.3175C20.4746 31.8063 20.7703 31.2861 21.2868 31.1476C21.785 31.0141 22.3195 31.3119 22.4565 31.823L25.2164 42.1254C25.3529 42.6347 25.0393 43.1618 24.5411 43.2953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0685 41.2774C31.5519 41.4158 31.0353 41.1112 30.8989 40.6019L28.1389 30.2996C28.002 29.7884 28.2976 29.2681 28.8142 29.1297C29.3308 28.9913 29.8469 29.294 29.9839 29.8051L32.7438 40.1075C32.8803 40.6168 32.5851 41.1389 32.0685 41.2774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0863 14.6345L30.7731 17.3985C30.275 17.532 29.7399 17.2324 29.6035 16.7231C29.4665 16.2119 29.7806 15.6867 30.2787 15.5532L40.5919 12.7892C41.0901 12.6557 41.6246 12.9535 41.7616 13.4646C41.898 13.9739 41.5844 14.501 41.0863 14.6345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1049 22.1672L32.7917 24.9312C32.2935 25.0647 31.7585 24.7651 31.622 24.2558C31.4851 23.7446 31.7992 23.2194 32.2973 23.0859L42.6105 20.3219C43.1086 20.1884 43.6432 20.4862 43.7802 20.9974C43.9166 21.5067 43.603 22.0337 43.1049 22.1672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7077 21.9721L3.41301 24.7311C2.89642 24.8696 2.3798 24.565 2.24336 24.0557C2.10643 23.5445 2.40208 23.0243 2.91866 22.8858L13.2134 20.1268C13.7299 19.9883 14.2461 20.2911 14.383 20.8022C14.5194 21.3115 14.2243 21.8336 13.7077 21.9721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7253 29.5053L5.43058 32.2643C4.914 32.4028 4.39738 32.0982 4.26094 31.5889C4.12401 31.0778 4.41965 30.5575 4.93623 30.419L15.2309 27.66C15.7475 27.5216 16.2637 27.8243 16.4006 28.3354C16.537 28.8447 16.2419 29.3669 15.7253 29.5053Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 45,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.b7ac4221efe47fd4ed94389a81f54870.svg";
export { ForwardRef as ReactComponent };